import './offer.scss';
import Swiper, { Navigation } from 'swiper';

class OfferSlider {
    constructor ($element) {
        this.$offerSlider = $element;
        this.$slider = this.$offerSlider.querySelector('[data-offer-slider="slider"]');
        this.$slidePrev = this.$offerSlider.querySelector('[data-offer-slider="prev"]');
        this.$slideNext = this.$offerSlider.querySelector('[data-offer-slider="next"]');
        this.$slides = this.$offerSlider.querySelectorAll('[data-offer-slider="slide"], [data-offer-slider="recommended"]');
        this.count = this.$slides.length;

        this.slider = null;
        this.centered = true;
        this.resizeTimeout = null;
    }

    initialize () {
        this.checkSize();
        this.setEvents();
    }

    setEvents () {
        window.addEventListener('resize', () => {
            this.resizeTimeout = setTimeout(() => {
                this.checkSize();
            }, 200);
        });
    }

    checkSize () {
        if (window.innerWidth < 768) {
            this.destroySlider();

            this.centered = this.count >= 3;
            this.initSlider();
        } else if (window.innerWidth < 1280) {
            this.destroySlider();

            if (this.count >= 3) {
                this.centered = true;
                this.initSlider();
            }
        } else if (window.innerWidth >= 1280 && window.innerWidth < 1920) {
            this.destroySlider();

            if (this.count > 3) {
                this.centered = true;
                this.initSlider();
            }
        } else if (window.innerWidth >= 1920) {
            this.destroySlider();
        }
    }

    initSlider () {
        console.log('init slider offer.js');
        const $recommendedIndex = this.$offerSlider.querySelector('[data-offer-slider="recommended"]');
        let initialSlide = 0;

        if ($recommendedIndex) {
            initialSlide = $recommendedIndex.getAttribute('data-index');
        }

        if (this.slider === null || typeof this.slider === 'undefined') {
            this.slider = new Swiper(this.$slider, {
                modules: [Navigation],
                slidesPerView: 'auto',
                resistanceRatio: 0,
                spaceBetween: 15,
                centeredSlides: this.centered,
                centeredSlidesBounds: this.centered,
                initialSlide: initialSlide, // eslint-disable-line
                speed: 500,
                navigation: {
                    prevEl: this.$slidePrev,
                    nextEl: this.$slideNext
                },
                breakpoints: {
                    768: {
                        spaceBetween: 30
                    }
                }
            });

            setTimeout(() => {
                this.slider.update();
            }, 500);
        }
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider.style = '';
            this.activeIndex = 0;
            this.slider = null;
        }
    }
}

export { OfferSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $offer = $context.querySelectorAll('[data-offer-slider="root"]');

        for (let i = 0; i < $offer.length; i++) {
            const $$offer = new OfferSlider($offer[i]);
            $$offer.initialize();
        }
    }
});
